import React, { createContext, useContext, useState, useEffect } from 'react';

// Complete translation data for all languages
const translations = {
    en: {
        // Navigation
        nav: {
            home: 'HOME',
            about: 'ABOUT',
            products: 'OUR PRODUCTS',
            news: 'NEWS & EVENTS',
            branches: 'BRANCHES',
            contact: 'CONTACT US',
            contactUs: 'CONTACT US',
        },
        // About dropdown
        aboutDropdown: {
            profile: 'Profile',
            overview: 'Overview',
            history: 'History',
            boardOfDirectors: 'Board of Directors',
            careers: 'Careers',
        },
        // Products
        productsDropdown: {
            leasingLoans: 'Leasing & Loans',
            goldLoan: 'Gold Loan',
            title: 'Our Products & Services',
        },
        // Footer
        footer: {
            quickLinks: 'Quick Links',
            contactInfo: 'Contact Info',
            followUs: 'Follow Us',
            copyright: 'All rights reserved.',
            address: 'Address',
            phone: 'Phone',
            email: 'Email',
            privacyPolicy: 'Privacy Policy',
            termsConditions: 'Terms & Conditions',
            sitemap: 'Sitemap',
            description: 'Pride Path Commercial (pvt) ltd is a leading financial institution, providing comprehensive financial solutions across Sri Lanka.',
        },
        // Common
        common: {
            learnMore: 'Learn More',
            applyNow: 'Apply Now',
            viewAll: 'View All',
            readMore: 'Read More',
            selectTimezone: 'Select Timezone',
            callNow: 'Call Now',
            callUs: 'Call Us',
            emailUs: 'Email Us',
            getStarted: 'Get Started',
            exploreProducts: 'Explore Products',
        },
        // Hero Section
        hero: {
            slide1Title: 'Rising Stronger, Rebuilding Together',
            slide1Subtitle: 'Pride Path Commercial (pvt) ltd - Group of Companies',
            slide1Desc: 'Over 600 employees, 12 branches, committed to excellence',
            slide2Title: 'Empowering Your Financial Dreams',
            slide2Subtitle: 'Trusted by Millions',
            slide2Desc: 'Competitive rates and personalized solutions for every need',
            slide3Title: 'Your Partner in Growth',
            slide3Subtitle: 'Since 2019',
            slide3Desc: 'Years of trusted financial services',
        },
        // Pages
        pages: {
            productsTitle: 'Our Products',
            productsSubtitle: 'Comprehensive financial solutions tailored to meet your unique needs.',
            aboutTitle: 'About Us',
            aboutSubtitle: 'Learn more about our company and values',
            newsTitle: 'News & Events',
            newsSubtitle: 'Stay updated with our latest news and events',
            contactTitle: 'Contact Us',
            contactSubtitle: 'Get in touch with our team',
            leasingLoansTitle: 'Leasing & Loans',
            leasingLoansSubtitle: 'Tailored financing solutions to help you achieve your goals.',
        },
        // Sections
        sections: {
            whyChooseUs: 'Why Choose Us',
            ourServices: 'Our Services',
            latestNews: 'Latest News',
            ourBranches: 'Our Branches',
            customerTestimonials: 'Customer Testimonials',
            quickApproval: 'Quick Approval',
            quickApprovalDesc: 'Get approved within 24 hours with minimal documentation',
            competitiveRates: 'Competitive Rates',
            competitiveRatesDesc: 'Enjoy some of the lowest interest rates in the market',
            flexibleTerms: 'Flexible Terms',
            flexibleTermsDesc: 'Customize your repayment schedule to fit your budget',
            expertSupport: 'Expert Support',
            expertSupportDesc: 'Dedicated relationship managers to guide you',
            readyToStart: 'Ready to Get Started?',
            readyToStartDesc: 'Contact us today to discuss your financing needs.',
            keyFeatures: 'Key Features',
            interestRates: 'Interest Rates',
            eligibility: 'Eligibility Criteria',
            requiredDocs: 'Required Documents',
            relatedProducts: 'Related Products',
        },
    },
    si: {
        // Navigation - Sinhala
        nav: {
            home: 'මුල් පිටුව',
            about: 'අප ගැන',
            products: 'අපගේ නිෂ්පාදන',
            news: 'පුවත් සහ සිදුවීම්',
            branches: 'ශාඛා',
            contact: 'සම්බන්ධ වන්න',
            contactUs: 'අප අමතන්න',
        },
        // About dropdown - Sinhala
        aboutDropdown: {
            profile: 'පැතිකඩ',
            overview: 'දළ විශ්ලේෂණය',
            history: 'ඉතිහාසය',
            boardOfDirectors: 'අධ්‍යක්ෂ මණ්ඩලය',
            careers: 'රැකියා අවස්ථා',
        },
        // Products - Sinhala
        productsDropdown: {
            leasingLoans: 'ලීසිං සහ ණය',
            goldLoan: 'රන් ණය',
            title: 'අපගේ නිෂ්පාදන සහ සේවා',
        },
        // Footer - Sinhala
        footer: {
            quickLinks: 'ඉක්මන් සබැඳි',
            contactInfo: 'සම්බන්ධතා තොරතුරු',
            followUs: 'අපව අනුගමනය කරන්න',
            copyright: 'සියලු හිමිකම් ආරක්ෂිතයි.',
            address: 'ලිපිනය',
            phone: 'දුරකථනය',
            email: 'විද්‍යුත් තැපෑල',
            privacyPolicy: 'රහස්‍යතා ප්‍රතිපත්තිය',
            termsConditions: 'නියමයන් සහ කොන්දේසි',
            sitemap: 'වෙබ් අඩවි සිතියම',
            description: 'ප්‍රයිඩ් පාත් කොමර්ෂල් (පුද්) සමාගම ශ්‍රී ලංකාව පුරා විස්තීර්ණ මූල්‍ය විසඳුම් සපයන ප්‍රමුඛ මූල්‍ය ආයතනයකි.',
        },
        // Common - Sinhala
        common: {
            learnMore: 'තව දැනගන්න',
            applyNow: 'දැන් අයදුම් කරන්න',
            viewAll: 'සියල්ල බලන්න',
            readMore: 'වැඩිදුර කියවන්න',
            selectTimezone: 'කාල කලාපය තෝරන්න',
            callNow: 'දැන් අමතන්න',
            callUs: 'අප අමතන්න',
            emailUs: 'විද්‍යුත් තැපෑල යවන්න',
            getStarted: 'ආරම්භ කරන්න',
            exploreProducts: 'නිෂ්පාදන ගවේෂණය කරන්න',
        },
        // Hero Section - Sinhala
        hero: {
            slide1Title: 'ශක්තිමත්ව නැගී සිටිමින්, එකට නැවත ගොඩනගමින්',
            slide1Subtitle: 'ප්‍රයිඩ් පාත් කොමර්ෂල් (පුද්) සමාගම - සමාගම් සමූහය',
            slide1Desc: 'සේවකයින් 600+, ශාඛා 12, විශිෂ්ටත්වයට කැපවී',
            slide2Title: 'ඔබේ මූල්‍ය සිහින සාක්ෂාත් කරමින්',
            slide2Subtitle: 'මිලියන ගණනක් විශ්වාස කරයි',
            slide2Desc: 'සෑම අවශ්‍යතාවයක් සඳහාම තරඟකාරී ගාස්තු සහ පුද්ගලික විසඳුම්',
            slide3Title: 'ඔබේ වර්ධනයේ හවුල්කරු',
            slide3Subtitle: '2019 සිට',
            slide3Desc: 'විශ්වාසදායක මූල්‍ය සේවා වර්ෂ ගණනාවක්',
        },
        // Pages - Sinhala
        pages: {
            productsTitle: 'අපගේ නිෂ්පාදන',
            productsSubtitle: 'ඔබේ අනන්‍ය අවශ්‍යතා සපුරාලීමට නිර්මාණය කළ විස්තීර්ණ මූල්‍ය විසඳුම්.',
            aboutTitle: 'අප ගැන',
            aboutSubtitle: 'අපගේ සමාගම සහ වටිනාකම් ගැන වැඩිදුර දැනගන්න',
            newsTitle: 'පුවත් සහ සිදුවීම්',
            newsSubtitle: 'අපගේ නවතම පුවත් සහ සිදුවීම් සමඟ යාවත්කාලීන වන්න',
            contactTitle: 'අප අමතන්න',
            contactSubtitle: 'අපගේ කණ්ඩායම සමඟ සම්බන්ධ වන්න',
            leasingLoansTitle: 'ලීසිං සහ ණය',
            leasingLoansSubtitle: 'ඔබේ ඉලක්ක සපුරා ගැනීමට සැලසුම් කළ මූල්‍ය විසඳුම්.',
        },
        // Sections - Sinhala
        sections: {
            whyChooseUs: 'අප තෝරන්නේ ඇයි',
            ourServices: 'අපගේ සේවාවන්',
            latestNews: 'නවතම පුවත්',
            ourBranches: 'අපගේ ශාඛා',
            customerTestimonials: 'පාරිභෝගික ප්‍රශංසා',
            quickApproval: 'ඉක්මන් අනුමැතිය',
            quickApprovalDesc: 'අවම ලේඛන සමඟ පැය 24 තුළ අනුමත වන්න',
            competitiveRates: 'තරඟකාරී ගාස්තු',
            competitiveRatesDesc: 'වෙළඳපොලේ අඩුම පොලී අනුපාත භුක්ති විඳින්න',
            flexibleTerms: 'නම්‍යශීලී නියමයන්',
            flexibleTermsDesc: 'ඔබේ අයවැයට ගැළපෙන පරිදි ආපසු ගෙවීම් කාලසටහන අභිරුචිකරණය කරන්න',
            expertSupport: 'විශේෂඥ සහාය',
            expertSupportDesc: 'ඔබට මඟ පෙන්වීමට කැපවූ සම්බන්ධතා කළමනාකරුවන්',
            readyToStart: 'ආරම්භ කිරීමට සූදානම්ද?',
            readyToStartDesc: 'ඔබේ මූල්‍ය අවශ්‍යතා සාකච්ඡා කිරීමට අදම අප අමතන්න.',
            keyFeatures: 'ප්‍රධාන ලක්ෂණ',
            interestRates: 'පොලී අනුපාත',
            eligibility: 'සුදුසුකම් නිර්ණායක',
            requiredDocs: 'අවශ්‍ය ලේඛන',
            relatedProducts: 'සම්බන්ධිත නිෂ්පාදන',
        },
    },
    ta: {
        // Navigation - Tamil
        nav: {
            home: 'முகப்பு',
            about: 'எங்களை பற்றி',
            products: 'எங்கள் தயாரிப்புகள்',
            news: 'செய்திகள் & நிகழ்வுகள்',
            branches: 'கிளைகள்',
            contact: 'தொடர்பு',
            contactUs: 'எங்களை தொடர்பு கொள்ளுங்கள்',
        },
        // About dropdown - Tamil
        aboutDropdown: {
            profile: 'சுயவிவரம்',
            overview: 'மேலோட்டம்',
            history: 'வரலாறு',
            boardOfDirectors: 'இயக்குநர்கள் குழு',
            careers: 'வேலைவாய்ப்புகள்',
        },
        // Products - Tamil
        productsDropdown: {
            leasingLoans: 'குத்தகை & கடன்கள்',
            goldLoan: 'தங்க கடன்',
            title: 'எங்கள் தயாரிப்புகள் & சேவைகள்',
        },
        // Footer - Tamil
        footer: {
            quickLinks: 'விரைவு இணைப்புகள்',
            contactInfo: 'தொடர்பு தகவல்',
            followUs: 'எங்களை பின்தொடரவும்',
            copyright: 'அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை.',
            address: 'முகவரி',
            phone: 'தொலைபேசி',
            email: 'மின்னஞ்சல்',
            privacyPolicy: 'தனியுரிமை கொள்கை',
            termsConditions: 'விதிமுறைகள் & நிபந்தனைகள்',
            sitemap: 'தள வரைபடம்',
            description: 'பிரைட் பாத் கமர்ஷியல் (பிவிடி) லிமிடெட் இலங்கை முழுவதும் விரிவான நிதி தீர்வுகளை வழங்கும் முன்னணி நிதி நிறுவனமாகும்.',
        },
        // Common - Tamil
        common: {
            learnMore: 'மேலும் அறிய',
            applyNow: 'இப்போது விண்ணப்பிக்கவும்',
            viewAll: 'அனைத்தையும் காண',
            readMore: 'மேலும் படிக்க',
            selectTimezone: 'நேர மண்டலத்தை தேர்ந்தெடுக்கவும்',
            callNow: 'இப்போது அழைக்கவும்',
            callUs: 'எங்களை அழைக்கவும்',
            emailUs: 'மின்னஞ்சல் அனுப்புங்கள்',
            getStarted: 'தொடங்குங்கள்',
            exploreProducts: 'தயாரிப்புகளை ஆராயுங்கள்',
        },
        // Hero Section - Tamil
        hero: {
            slide1Title: 'வலுவாக உயர்ந்து, ஒன்றாக மீண்டும் கட்டமைக்கிறோம்',
            slide1Subtitle: 'பிரைட் பாத் கமர்ஷியல் (பிவிடி) லிமிடெட் - நிறுவனங்களின் குழு',
            slide1Desc: '600+ ஊழியர்கள், 12 கிளைகள், சிறப்புக்கு அர்ப்பணிப்பு',
            slide2Title: 'உங்கள் நிதி கனவுகளை சாத்தியமாக்குகிறோம்',
            slide2Subtitle: 'மில்லியன் கணக்கானோர் நம்புகிறார்கள்',
            slide2Desc: 'ஒவ்வொரு தேவைக்கும் போட்டி விலைகள் மற்றும் தனிப்பயனாக்கப்பட்ட தீர்வுகள்',
            slide3Title: 'உங்கள் வளர்ச்சியில் கூட்டாளி',
            slide3Subtitle: '2019 முதல்',
            slide3Desc: 'நம்பகமான நிதி சேவைகளில் ஆண்டுகள்',
        },
        // Pages - Tamil
        pages: {
            productsTitle: 'எங்கள் தயாரிப்புகள்',
            productsSubtitle: 'உங்கள் தனித்துவமான தேவைகளை பூர்த்தி செய்ய வடிவமைக்கப்பட்ட விரிவான நிதி தீர்வுகள்.',
            aboutTitle: 'எங்களை பற்றி',
            aboutSubtitle: 'எங்கள் நிறுவனம் மற்றும் மதிப்புகளைப் பற்றி மேலும் அறிக',
            newsTitle: 'செய்திகள் & நிகழ்வுகள்',
            newsSubtitle: 'எங்கள் சமீபத்திய செய்திகள் மற்றும் நிகழ்வுகளுடன் புதுப்பித்த நிலையில் இருங்கள்',
            contactTitle: 'எங்களை தொடர்பு கொள்ளுங்கள்',
            contactSubtitle: 'எங்கள் குழுவுடன் தொடர்பில் இருங்கள்',
            leasingLoansTitle: 'குத்தகை & கடன்கள்',
            leasingLoansSubtitle: 'உங்கள் இலக்குகளை அடைய உதவும் தனிப்பயனாக்கப்பட்ட நிதி தீர்வுகள்.',
        },
        // Sections - Tamil
        sections: {
            whyChooseUs: 'ஏன் எங்களை தேர்வு செய்ய வேண்டும்',
            ourServices: 'எங்கள் சேவைகள்',
            latestNews: 'சமீபத்திய செய்திகள்',
            ourBranches: 'எங்கள் கிளைகள்',
            customerTestimonials: 'வாடிக்கையாளர் சான்றுகள்',
            quickApproval: 'விரைவான ஒப்புதல்',
            quickApprovalDesc: 'குறைந்தபட்ச ஆவணங்களுடன் 24 மணி நேரத்திற்குள் ஒப்புதல் பெறுங்கள்',
            competitiveRates: 'போட்டி விலைகள்',
            competitiveRatesDesc: 'சந்தையில் மிகக் குறைந்த வட்டி விகிதங்களை அனுபவிக்கவும்',
            flexibleTerms: 'நெகிழ்வான விதிமுறைகள்',
            flexibleTermsDesc: 'உங்கள் பட்ஜெட்டுக்கு ஏற்ப திருப்பிச் செலுத்தும் அட்டவணையை தனிப்பயனாக்குங்கள்',
            expertSupport: 'நிபுணர் ஆதரவு',
            expertSupportDesc: 'உங்களுக்கு வழிகாட்ட அர்ப்பணிப்புள்ள உறவு மேலாளர்கள்',
            readyToStart: 'தொடங்க தயாரா?',
            readyToStartDesc: 'உங்கள் நிதி தேவைகளை விவாதிக்க இன்றே எங்களை தொடர்பு கொள்ளுங்கள்.',
            keyFeatures: 'முக்கிய அம்சங்கள்',
            interestRates: 'வட்டி விகிதங்கள்',
            eligibility: 'தகுதி அளவுகோல்கள்',
            requiredDocs: 'தேவையான ஆவணங்கள்',
            relatedProducts: 'தொடர்புடைய தயாரிப்புகள்',
        },
    },
};

// Language display names
const languageNames = {
    en: { short: 'EN', full: 'English' },
    si: { short: 'සිං', full: 'සිංහල' },
    ta: { short: 'த', full: 'தமிழ்' },
};

// Create context
const LanguageContext = createContext();

// Provider component
export const LanguageProvider = ({ children }) => {
    const [language, setLanguageState] = useState(() => {
        if (typeof window !== 'undefined') {
            return localStorage.getItem('siteLanguage') || 'en';
        }
        return 'en';
    });

    useEffect(() => {
        localStorage.setItem('siteLanguage', language);
    }, [language]);

    const setLanguage = (lang) => {
        if (translations[lang]) {
            setLanguageState(lang);
        }
    };

    // Translation function - supports nested keys like 'nav.home'
    const t = (key) => {
        const keys = key.split('.');
        let value = translations[language];

        for (const k of keys) {
            if (value && value[k]) {
                value = value[k];
            } else {
                // Fallback to English
                value = translations['en'];
                for (const k2 of keys) {
                    if (value && value[k2]) {
                        value = value[k2];
                    } else {
                        return key;
                    }
                }
                break;
            }
        }

        return typeof value === 'string' ? value : key;
    };

    const value = {
        language,
        setLanguage,
        t,
        languageNames,
        availableLanguages: Object.keys(translations),
    };

    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
};

export default LanguageContext;
